import { render, staticRenderFns } from "./SkeletonBlock.vue?vue&type=template&id=768c3f95&scoped=true&"
import script from "./SkeletonBlock.vue?vue&type=script&lang=js&"
export * from "./SkeletonBlock.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonBlock.vue?vue&type=style&index=0&id=768c3f95&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768c3f95",
  null
  
)

export default component.exports